import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPreviousPath } from '../../utils/navigationHistory';
import './MobileBackButton.scss';

// Minimal floating back arrow for mobile — no pill, no label, just the glyph.
// Uses in-session history to return to the page the user actually came from,
// falling back to the provided default (e.g. the section index). Only shown
// on phones.
const MobileBackButton = ({ fallbackTo = '/' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = window.setTimeout(() => setVisible(true), 300);
    return () => window.clearTimeout(t);
  }, []);

  const handleBack = () => {
    const prev = getPreviousPath();
    // Prefer the recorded previous path if it is a different internal route.
    if (prev && prev !== location.pathname && !prev.startsWith('/admin')) {
      navigate(prev);
    } else if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallbackTo);
    }
  };

  return (
    <button
      type="button"
      className={`av-back-btn${visible ? ' is-visible' : ''}`}
      onClick={handleBack}
      aria-label="Go back"
    >
      <i className="fas fa-arrow-left av-back-icon" aria-hidden="true" />
    </button>
  );
};

export default MobileBackButton;